/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
import AccordionList from '../components/AccordionList';
import AgeInfoBox from '../components/AgeInfoBox';
import Dev from '../components/app/Dev';
import Layout from '../components/app/Layout';
import LoadingSpinner from '../components/app/LoadingSpinner';
import RouteLoading from '../components/app/RouteLoading';
import StepsContainer from '../components/app/StepsContainer';
import AuthInfo from '../components/AuthInfo';
import AuthLogin from '../components/AuthLogin';
import Basket from '../components/Basket';
import ButtonWithBack from '../components/ButtonWithBack';
import Consent from '../components/Consent';
import ControlServiceProduct from '../components/ControlServiceProduct';
import DatePicker from '../components/DatePicker';
import DigitalSecurity from '../components/DigitalSecurity';
import ExtraSim from '../components/ExtraSim';
import FlowSelectorLogin from '../components/FlowSelectorLogin';
import FlowSelectorNavigation from '../components/FlowSelectorNavigation';
import FlowSelectorNavigationTrumf from '../components/FlowSelectorNavigationTrumf';
import FlowSelectorSwitch from '../components/FlowSelectorSwitch';
import FlowSelectorSwitchTrumf from '../components/FlowSelectorSwitchTrumf';
import HeadingCurrentUser from '../components/HeadingCurrentUser';
import HeadingWithBottomsheet from '../components/HeadingWithBottomsheet';
import IconList from '../components/IconList';
import IconListThree from '../components/IconListThree';
import LongText from '../components/LongText';
import OidcRedirect from '../components/OidcRedirect';
import Overlay from '../components/Overlay';
import OverlayButton from '../components/OverlayButton';
import OverlayMulti from '../components/OverlayMulti';
import Postal from '../components/Postal';
import ProductList from '../components/ProductList';
import ProductListMulti from '../components/ProductListMulti';
import RecruitmentInfo from '../components/RecruitmentInfo';
import RecruitmentSpot from '../components/RecruitmentSpot';
import SimNextSteps from '../components/SimNextSteps';
import SubscriptionList from '../components/SubscriptionList';
import SubscriptionListTrumf from '../components/SubscriptionListTrumf';
import Summary from '../components/Summary';
import Terms from '../components/Terms';
import UserOverview from '../components/UserOverview';
import UserSelector from '../components/UserSelector';
import BottomSheet from '../components/util/BottomSheet';
import FlowSelector from '../components/util/FlowSelector';
import Membership from '../components/util/Membership';
import Recruitment from '../components/util/Recruitment';
import SpotList from '../components/util/SpotList';
import SummaryContent from '../components/util/SummaryContent';
import SummaryDigitalSecurity from '../components/util/SummaryDigitalSecurity';
import SummaryExtraSim from '../components/util/SummaryExtraSim';
import SummaryMembership from '../components/util/SummaryMembership';
import SummaryProductTitle from '../components/util/SummaryProductTitle';
import Underline from '../components/util/Underline';
import Footer from '../../../Talkmore.Web.Vue.Shared/src/components/app/Footer';
import Logo from '../../../Talkmore.Web.Vue.Shared/src/components/app/Logo';
import NotFound from '../../../Talkmore.Web.Vue.Shared/src/components/app/NotFound';
import VisitorIdentification from '../../../Talkmore.Web.Vue.Shared/src/components/app/VisitorIdentification';
import Button from '../../../Talkmore.Web.Vue.Shared/src/components/Button';
import Calendar from '../../../Talkmore.Web.Vue.Shared/src/components/Calendar';
import CheckBox from '../../../Talkmore.Web.Vue.Shared/src/components/CheckBox';
import ChoiceModal from '../../../Talkmore.Web.Vue.Shared/src/components/ChoiceModal';
import Header from '../../../Talkmore.Web.Vue.Shared/src/components/Header';
import Heading from '../../../Talkmore.Web.Vue.Shared/src/components/Heading';
import HeadingWithText from '../../../Talkmore.Web.Vue.Shared/src/components/HeadingWithText';
import IconInfoBox from '../../../Talkmore.Web.Vue.Shared/src/components/IconInfoBox';
import InfoBox from '../../../Talkmore.Web.Vue.Shared/src/components/InfoBox';
import InputField from '../../../Talkmore.Web.Vue.Shared/src/components/InputField';
import LinkCard from '../../../Talkmore.Web.Vue.Shared/src/components/LinkCard';
import LinkText from '../../../Talkmore.Web.Vue.Shared/src/components/LinkText';
import MessageBox from '../../../Talkmore.Web.Vue.Shared/src/components/MessageBox';
import Modal from '../../../Talkmore.Web.Vue.Shared/src/components/Modal';
import ModalChoice from '../../../Talkmore.Web.Vue.Shared/src/components/ModalChoice';
import RadioButton from '../../../Talkmore.Web.Vue.Shared/src/components/RadioButton';
import Receipt from '../../../Talkmore.Web.Vue.Shared/src/components/Receipt';
import RichText from '../../../Talkmore.Web.Vue.Shared/src/components/RichText';
import TermsModalLink from '../../../Talkmore.Web.Vue.Shared/src/components/TermsModalLink';
import ToggleButton from '../../../Talkmore.Web.Vue.Shared/src/components/ToggleButton';
import Animation from '../../../Talkmore.Web.Vue.Shared/src/components/util/Animation';
import CtaButton from '../../../Talkmore.Web.Vue.Shared/src/components/util/CtaButton';
import DarkOverlay from '../../../Talkmore.Web.Vue.Shared/src/components/util/DarkOverlay';
import ModalOverlay from '../../../Talkmore.Web.Vue.Shared/src/components/util/ModalOverlay';
import Pill from '../../../Talkmore.Web.Vue.Shared/src/components/util/Pill';
import Seperator from '../../../Talkmore.Web.Vue.Shared/src/components/util/Seperator';
import Spinner from '../../../Talkmore.Web.Vue.Shared/src/components/util/Spinner';
import Tooltip from '../../../Talkmore.Web.Vue.Shared/src/components/util/Tooltip';

const components = new Map();
components.set('AccordionList', AccordionList);
components.set('AgeInfoBox', AgeInfoBox);
components.set('Dev', Dev);
components.set('Layout', Layout);
components.set('LoadingSpinner', LoadingSpinner);
components.set('RouteLoading', RouteLoading);
components.set('StepsContainer', StepsContainer);
components.set('AuthInfo', AuthInfo);
components.set('AuthLogin', AuthLogin);
components.set('Basket', Basket);
components.set('ButtonWithBack', ButtonWithBack);
components.set('Consent', Consent);
components.set('ControlServiceProduct', ControlServiceProduct);
components.set('DatePicker', DatePicker);
components.set('DigitalSecurity', DigitalSecurity);
components.set('ExtraSim', ExtraSim);
components.set('FlowSelectorLogin', FlowSelectorLogin);
components.set('FlowSelectorNavigation', FlowSelectorNavigation);
components.set('FlowSelectorNavigationTrumf', FlowSelectorNavigationTrumf);
components.set('FlowSelectorSwitch', FlowSelectorSwitch);
components.set('FlowSelectorSwitchTrumf', FlowSelectorSwitchTrumf);
components.set('HeadingCurrentUser', HeadingCurrentUser);
components.set('HeadingWithBottomsheet', HeadingWithBottomsheet);
components.set('IconList', IconList);
components.set('IconListThree', IconListThree);
components.set('LongText', LongText);
components.set('OidcRedirect', OidcRedirect);
components.set('Overlay', Overlay);
components.set('OverlayButton', OverlayButton);
components.set('OverlayMulti', OverlayMulti);
components.set('Postal', Postal);
components.set('ProductList', ProductList);
components.set('ProductListMulti', ProductListMulti);
components.set('RecruitmentInfo', RecruitmentInfo);
components.set('RecruitmentSpot', RecruitmentSpot);
components.set('SimNextSteps', SimNextSteps);
components.set('SubscriptionList', SubscriptionList);
components.set('SubscriptionListTrumf', SubscriptionListTrumf);
components.set('Summary', Summary);
components.set('Terms', Terms);
components.set('UserOverview', UserOverview);
components.set('UserSelector', UserSelector);
components.set('BottomSheet', BottomSheet);
components.set('FlowSelector', FlowSelector);
components.set('Membership', Membership);
components.set('Recruitment', Recruitment);
components.set('SpotList', SpotList);
components.set('SummaryContent', SummaryContent);
components.set('SummaryDigitalSecurity', SummaryDigitalSecurity);
components.set('SummaryExtraSim', SummaryExtraSim);
components.set('SummaryMembership', SummaryMembership);
components.set('SummaryProductTitle', SummaryProductTitle);
components.set('Underline', Underline);
components.set('Footer', Footer);
components.set('Logo', Logo);
components.set('NotFound', NotFound);
components.set('VisitorIdentification', VisitorIdentification);
components.set('Button', Button);
components.set('Calendar', Calendar);
components.set('CheckBox', CheckBox);
components.set('ChoiceModal', ChoiceModal);
components.set('Header', Header);
components.set('Heading', Heading);
components.set('HeadingWithText', HeadingWithText);
components.set('IconInfoBox', IconInfoBox);
components.set('InfoBox', InfoBox);
components.set('InputField', InputField);
components.set('LinkCard', LinkCard);
components.set('LinkText', LinkText);
components.set('MessageBox', MessageBox);
components.set('Modal', Modal);
components.set('ModalChoice', ModalChoice);
components.set('RadioButton', RadioButton);
components.set('Receipt', Receipt);
components.set('RichText', RichText);
components.set('TermsModalLink', TermsModalLink);
components.set('ToggleButton', ToggleButton);
components.set('Animation', Animation);
components.set('CtaButton', CtaButton);
components.set('DarkOverlay', DarkOverlay);
components.set('ModalOverlay', ModalOverlay);
components.set('Pill', Pill);
components.set('Seperator', Seperator);
components.set('Spinner', Spinner);
components.set('Tooltip', Tooltip);

export default function componentFactory(componentName) {
  return components.get(componentName);
};
